(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pm-editorial-hero')) {
 customElements.define('pm-editorial-hero', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   this.panels = [...this.querySelectorAll('[data-panel]')];
   this.buttons = [...this.querySelectorAll('[data-panel-button]')];
   this.classList.add('is-interactive'); this.select(0);
   this.buttons.forEach((button, i) => button.addEventListener('click', () => this.select(i), {signal:this.controller.signal}));
   this.addEventListener('shopify:block:select', (event) => {const panel=event.target.closest('[data-panel]');if(panel)this.select(Number(panel.dataset.panel));}, {signal:this.controller.signal});
  }
  select(index) {this.panels.forEach((panel,i)=>panel.hidden=i!==index);this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));}
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
